import { CircleCheckIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

// Card-top strip shown on the collection whose collaborator access was just
// saved. Same shape as the "Published just now" toaster the EXO AI flow shows
// over the list, but scoped to the affected card, cleared by the card after a
// few seconds, and coloured from design-system tokens rather than hex values.
function AccessUpdatedToaster() {
  return (
    <div
      className="-mx-2.5 -mt-6 mb-4 flex items-center gap-2 rounded-t-md border-b border-b-primary/30 bg-primary/10 px-8 py-1.5 lg:-mx-8"
      role="status"
      data-intercom-target="collaborator-access-updated-toaster"
    >
      <CircleCheckIcon color="inherit" className="text-primary" />
      <Typography variant="bodyMedium" fontWeight="medium">
        <T kind="Collaborator access updated just now" />
      </Typography>
    </div>
  );
}

export default observer(AccessUpdatedToaster);
